module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_1_1@2x.051b1d65.png";